import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { store } from "./helpers";

const SW_UPDATE_CHECK_COOLDOWN = 300000;
const SW_STATUS_CHECK_TIME_INTERVAL = 5000;
let initialSWStatusCheckInterval = null;

export function serviceWorker() {
  serviceWorkerRegistration.register();
  serviceWorkerRegistration.registerNotification();
  listenAppVersion();
  addListenerOnceSWInstall();
}

function addReloadContollerListener() {
  if("serviceWorker" in navigator) {
    window.navigator.serviceWorker.addEventListener('controllerchange',
      () => {
        store.dispatch({ type: 'OPEN_DIALOG' });
      }
    );
  }
}
async function addSWControllerListenerOnceInstalled() {
  if(Boolean(navigator?.serviceWorker?.controller) && (await navigator?.serviceWorker?.getRegistrations())?.length > 0) {
    clearInterval(initialSWStatusCheckInterval)
    addReloadContollerListener();
    console.log("App Updates Activated");
  }
}
async function addListenerOnceSWInstall() {
  console.log("addListenerOnceSWInstall------")
  initialSWStatusCheckInterval = setInterval(addSWControllerListenerOnceInstalled, SW_STATUS_CHECK_TIME_INTERVAL);
}
function listenAppVersion() {
  console.log("listenAppVersion------")
  document.body.addEventListener("click", () => {
    executeCallbackOnlyIfNotInCooldown("nextServiceWorkerUpdateCheck", SW_UPDATE_CHECK_COOLDOWN, appUpdateAction);
  });
}

async function executeCallbackOnlyIfNotInCooldown(storageKey, COOL_DOWN_INTERVAL, callback) {
  const nextCallbackDttm = localStorage.getItem(storageKey);
  if (
    !nextCallbackDttm || 
    (
      nextCallbackDttm &&
      Number(nextCallbackDttm) &&
      Date.now() > Number(nextCallbackDttm)
    )
  ) {
    localStorage.setItem(storageKey, Date.now() + Number(COOL_DOWN_INTERVAL));
    callback();
  }
}

const appUpdateAction = async () => {
  serviceWorkerRegistration.updateSW();
};
